import { Reveal } from "./Reveal";
import { faqs } from "@/data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Faq = () => {
  return (
    <section id="faq" className="bg-ivory py-24 sm:py-36" data-testid="faq">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[0.5fr_1fr] gap-10 lg:gap-16">
          <div>
            <Reveal>
              <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 11 — FAQ</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-ink text-4xl sm:text-5xl leading-[1.05] tracking-tight lg:sticky lg:top-28">
                Domande frequenti.
              </h2>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="border-t hairline">
              {faqs.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-accordion-item-${i + 1}`} className="border-b hairline">
                  <AccordionTrigger className="font-display text-xl sm:text-2xl text-ink text-left hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-sans-ui text-sm sm:text-base text-ink/65 leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
